export * from './src/localize-router.module';
export * from './src/localize-router.parser';
export * from './src/localize-router.service';
export * from './src/localize-router.pipe';
export * from './src/localize-router.config';
export * from './src/localize-router-config-loader';



// WEBPACK FOOTER //
// ./~/tslint-loader!./index.ts